import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-backoffice-dashboard',
  templateUrl: './backoffice-dashboard.component.html',
  styleUrls: ['./backoffice-dashboard.component.scss']
})
export class BackofficeDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
